import { useState, useEffect } from 'react'
import { useCustomAxios } from '../../axiosInstance'
import FormButton from '../../components/FormButton/FormButton'
import Input from '../../components/Input/Input'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader
import '../Login/login.css'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import { toastError, toastSuccess } from '../../util/toastUtil'

import MuiPasswordInput from '../../components/MaterialComponent/MuiPasswordInput'
import MuiButton from '../../components/MaterialComponent/MuiButton'
import { RESETPASSWORD_ENDPOINTS } from '../../constants/apiConstants'

const NewPassowrd = ({ setCurrentStep, STEP, setLoadingData }) => {
    const axios = useCustomAxios()
    const [newpassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')

    function validatepassword(paswrd) {
        if (
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\(\)_\+\-=\[\]\{\};':"\\|,.<>\/?~`])(?=.{10,20})/.test(
                paswrd
            )
        ) {
            return false
        } else {
            return true
        }
    }

    const handleOtpSubmit = async (e) => {
        e.preventDefault()

        if (newpassword !== confirmPassword) {
            toastError('Passwords do not match. Please try again.')
            return
        }

        if (validatepassword(newpassword)) {
            toastError(
                'Password does not meet the required criteria (see below for the criteria)  Please try again.'
            )
            return
        }

        const data = {
            password: newpassword,
        }

        const options = {
            headers: { 'content-type': 'application/json' },
        }

        try {
            setLoadingData(true)
            const response = await axios.post(
                RESETPASSWORD_ENDPOINTS.UPDATEPASSWORD,
                data,
                options
            )
            const baseUrl = process.env.PUBLIC_URL
            // console.log(response);
            if (response.status === 200) {
                toastSuccess(response.data)
                setTimeout(() => {
                    window.parent.postMessage(
                        {
                            status: 'completed',
                            message: 'Form submission successful',
                        },
                        `${baseUrl}/forgot-password-tmdsas`
                    ) // Consider specifying the exact domain instead of '*' for security
                }, 500)
            } else {
                toastError('Unable to reset password, please try again.')
            }
            setLoadingData(false)
        } catch (error) {
            // console.error('An error occurred during password reset:', error)
            setLoadingData(false)
            toastError('Unable to reset password, please try again.')
        }
    }
    const handleMouseDownPassword = (event) => {
        event.preventDefault()
    }
    return (
        <>
            <form
                className="form"
                style={{ maxWidth: '600px', minWidth: '550px' }}
                onSubmit={handleOtpSubmit}>
                <h5>Reset Forgotten Password</h5>
                {/* <h6 style={{ fontWeight: 'bold' }}>Select the method of sending a one time passcode </h6> */}
                <FormControl style={{ width: '100%' }}>
                    <FormLabel
                        id="demo-radio-buttons-group-label"
                        style={{ fontWeight: 'bold' }}>
                        Change your Password
                    </FormLabel>
                    <em style={{ maxWidth: '100%', fontSize: 15 }}>
                        {' '}
                        Update your <strong>strong password</strong> by meeting
                        the following requirements: At least 1 lower case
                        letter, At least 1 upper case letter, At least 1 special
                        character, At least 1 number and At least 10 characters
                        in length
                    </em>
                    <MuiPasswordInput
                        name="password"
                        label={'New Password'}
                        value={newpassword}
                        id="password"
                        onChange={(e) => setNewPassword(e.target.value)}
                        error={''}
                    />
                    <MuiPasswordInput
                        name="password"
                        label={'Confirm Password'}
                        value={confirmPassword}
                        id="password"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        error={''}
                    />
                </FormControl>

                <MuiButton>Submit</MuiButton>
            </form>
        </>
    )
}
export default NewPassowrd
